<template>
  <!-- eslint-disable max-len -->
  <div>
    <v-data-table
      width="100%"
      height="70vh"
      :sort-by.sync="pagination.sortBy"
      :sort-desc.sync="pagination.descending"
      :items-per-page.sync="pagination.rowsPerPage"
      hide-default-footer
      fixed-header
      :headers="headers"
      :search="search"
      :items="users"
      class="table elevation-0"
    >
      <template v-slot:header="{ header }">
        <tr class="table__header-row">
          <th
            v-for="h in header"
            :key="h.text"
            :class="['table__header', h.text, h.text !== 'ACTIONS' ? 'column_sortable' : '', pagination.descending ? 'desc' : 'asc', h.value === pagination.sortBy ? 'active' : '']"
            @click="h.text !== 'ACTIONS' ? changeSort(h.value) : () => {}"
          >
            {{ h.text }}
            <v-icon
              v-if="!pagination.descending && h.value === pagination.sortBy"
              class="table__header-icon"
              small
            >arrow_upward</v-icon>
            <v-icon
              v-if="pagination.descending && h.value === pagination.sortBy"
              class="table__header-icon"
              small
            >arrow_downward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:item="{ item }">
        <tr :class="[ 'table__row' ]">
          <td class="table__cell name">{{ item.name }}</td>
          <td class="table__cell email">{{ item.email }}</td>
          <td class="table__cell isActive">
            <button class="checkbox-btn" @click="handleOpenModal('activeModal', item.active, item.id)">
              <v-icon v-if="item.active" :color="'#51b71b'">mdi-radiobox-marked</v-icon>
              <v-icon v-if="!item.active" :color="'#a9a9a9'">mdi-radiobox-blank</v-icon>
            </button>
          </td>
          <td class="table__cell isAdmin">
            <button class="checkbox-btn" @click="handleOpenModal('adminModal', item.admin, item.id)">
              <v-icon v-if="item.admin" :color="'#000'">mdi-checkbox-marked</v-icon>
              <v-icon v-if="!item.admin" :color="'#A9A9A9'">mdi-checkbox-blank-outline</v-icon>
            </button>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <div v-if="loading">
          <span>Loading data, please wait...</span>
        </div>
        <div v-else>
          <span>No records available for this view</span>
        </div>
      </template>
    </v-data-table>
    <Modal v-if="isOpen" :modalType="modalType" :active="active" v-on:cancel="handleCloseModal" v-on:confirm="handleConfirmModal" />
  </div>
</template>

<script>
import Modal from './Modal';
import API from '../services/API';

export default {
  name: 'Orders-Table',
  props: ['search', 'users', 'loading'],
  components: {
    Modal,
  },
  data() {
    return {
      pagination: { sortBy: 'timeStamp', descending: true, rowsPerPage: -1 },
      isOpen: false,
      active: false,
      activeUser: null,
      modalType: 'adminModal', // the default - modal type is set when it opens
      headers: [
        {
          text: 'NAME',
          align: 'left',
          value: 'name',
        },
        { text: 'EMAIL', value: 'email' },
        { text: 'ACTIVE', value: 'active' },
        { text: 'ADMIN', value: 'admin' },
      ],
    };
  },
  methods: {
    changeSort(column) {
      console.log('sort by: ', column);
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    refreshUsers() {
      this.$emit('refresh');
    },
    handleCloseModal() {
      this.isOpen = false;
    },
    handleConfirmModal() {
      let set = !!this.active;
      if (this.modalType === 'adminModal') {
        set = { admin: !this.active };
      }
      if (this.modalType === 'activeModal') {
        set = { active: !this.active };
      }
      API.put(`/users/${this.activeUser}`, set).then(() => {
        this.handleCloseModal();
        this.refreshUsers();
      }).catch((error) => {
        console.error(error);
      });
      this.handleCloseModal();
    },
    handleOpenModal(modalType, isOn, id) {
      console.log('open - ison: ', isOn);
      this.active = isOn;
      this.modalType = modalType;
      this.activeUser = id;
      this.isOpen = true;
    },
  },
};
</script>

<style lang="scss" scoped>
tbody tr:nth-of-type(odd) {
  background-color: #f6f6f6;

  &:hover {
    background-color: #f6f6f6 !important;
  }
}

tbody tr:nth-of-type(even) {
  &:hover {
    background-color: #fff !important;
  }
}

.modal-btn {
  font-family: Heebo;
  letter-spacing: 0.5px;
  font-size: 1.5rem;
  line-height: 24px;
  text-align: center;
  text-transform: none;
  width: 120px;

  &__container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 25px 30px 5px 30px;
  }

  &.confirm {
    color: #fff;
  }
}

.table {
  width: 100%;

  .column_sortable {
    cursor: pointer;
  }

  &__header-row {
    border-bottom: 2px solid #a9a9a9 !important;
  }

  &__header {
    height: 2.1rem;
    color: #212121 !important;
    font-family: Heebo;
    font-size: 1.4rem !important;
    font-weight: bold;
    letter-spacing: 0.124rem;
    line-height: 2.1rem;
    text-align: left;
    padding: 0 0.5rem !important;

    &-icon {
      transform: translateY(-4px);
    }
  }

  &__row {
    height: 5.2rem !important;
  }

  &__cell {
    color: #212121;
    font-family: Heebo;
    font-size: 1.4rem;
    line-height: 2.1rem;

    .checkbox-btn {
      background: transparent;
      outline: none;
    }
  }

  .full,
  .urgent {
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  .full {
    width: 11rem;
    height: 5.2rem;
  }

  .urgent {
    width: 7rem;
    transform: translateY(-6px);
  }

  .actions {
    width: 8rem;
    padding: 0 !important;

    & > * {
      display: block;
      width: 50%;
      text-align: center;
      float: left;
    }
  }

  td:not(.process-error-border) {
    border-left: 8px solid transparent;
  }

  .process-error {
    background-color: #f6e6e6;

    &:hover {
      background-color: #f6e6e6 !important;
    }

    &-border {
      border-left: 8px solid #cb201f;
    }
  }
}

.download {
  text-decoration: none;
}
</style>

